import { render, staticRenderFns } from "./AddToppingMenu.vue?vue&type=template&id=76c0839b&scoped=true"
import script from "./AddToppingMenu.vue?vue&type=script&lang=js"
export * from "./AddToppingMenu.vue?vue&type=script&lang=js"
import style0 from "./AddToppingMenu.vue?vue&type=style&index=0&id=76c0839b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c0839b",
  null
  
)

export default component.exports